(function () {
    'use strict';

    angular
        .module('core.services')
        .service('DocumentTypeService', DocumentTypeService)

    /** @ngInject */
    function DocumentTypeService(HttpService) {
        const DocumentTypeService = {
            getAll
        }

        return DocumentTypeService;

        function getAll() {
            return HttpService.get('/people/documents/types');
        }
    }
}());